import { render, staticRenderFns } from "./lklOpening.vue?vue&type=template&id=47c517bd&scoped=true&"
import script from "./lklOpening.vue?vue&type=script&lang=js&"
export * from "./lklOpening.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47c517bd",
  null
  
)

export default component.exports